import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import { NotificationsService } from 'angular2-notifications';

import { User, UserComment } from '../../../entities/index';
import { UserCommentService } from '../../../services/usercomment.service';
import { Log } from '../../../utils/index';

@Component({
  selector: 'app-user-comments',
  templateUrl: './user-comments.html'
})
export class UserCommentsComponent {
  _user: User;
  comments: UserComment[] = [];
  new_comment: UserComment = new UserComment();

  constructor(protected router: Router,
              protected userCommentService: UserCommentService,
              protected notificationService: NotificationsService) {
  }

  @Input()
  set user(user: User) {
    this._user = user;
    if (this._user && this._user.id) {
      this.clearNewCommentForm();
      this.loadComments(this._user);
    }
  }

  get user() {
    return this._user;
  }

  clearNewCommentForm() {
    this.new_comment = new UserComment();
    this.new_comment.user_id = this.user.id;
  }

  loadComments(user: User) {
    this.userCommentService
      .listAllByUser(user.id)
      .subscribe(comments => {
        this.comments = comments;
      });
  }

  @Log('blue')
  saveComment() {
    this.userCommentService
      .saveComment(this.new_comment)
      .subscribe(comment => {
        this.comments.unshift(comment);
        this.notificationService.success('SUCCESS', 'The comment has been added.');
        this.clearNewCommentForm();
      });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/blocks/user-comments/user-comments.component.ts